<div class="upload-container image-wrap">
  <div class="image-content upload-wrapper" [ngClass]="{ hidden: (model && model.data) || model.pending }">
    <label for="ImageDownload" class="image-button">
      <span [innerText]="buttonCaption | translate"></span>
      <input id="ImageDownload" type="file" [accept]="supportedExtensions" multiple (change)="fileChange(input.files)" #input />
    </label>

    <p class="image-description">{{ description }}</p>
  </div>
  <div *ngIf="model.pending" class="loading-overlay">
    <app-loading [isRadial]="true"></app-loading>
  </div>
  <a class="clear-btn" (click)="clear()" *ngIf="model && model.data && !model.pending">
    <svg class="icon-svg">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-clear"></use>
    </svg>
  </a>

  <div class="image-wrapper" *ngIf="model && model.data && !model.pending">
    <img style="max-height: 100%; max-width: 100%" [src]="model.data | safeHtml" alt="" />
  </div>
</div>
